module.exports = __webpack_public_path__ + "media/images/beaf_and_pork_pre-325e8b9a0cb0b8a8cf80ea2b7128188f.jpg";